import React from 'react';
import './GenerationCue.css';

const GenerationCue = ({
  icon = '✨',
  message = 'GENERATING...',
  visible = true,
  className = '',
  showProgress = true,
}) => (
  <div
    className={`generation-cue ${visible ? 'is-visible' : ''} ${className}`.trim()}
    role="status"
    aria-live="polite"
  >
    {icon && <div className="generation-cue__icon" aria-hidden="true">{icon}</div>}
    <div className="generation-cue__message">{message}</div>
    {showProgress && (
      <div className="generation-cue__progress" aria-hidden="true">
        <div className="generation-cue__progress-sweep" />
      </div>
    )}
  </div>
);

export default GenerationCue;
